import { getImageSourcesForSEO } from 'editorial/utils/getImageSourcesForSeo';
import { getRedirectionPath } from 'localization/utils/getRedirectionPath';

export const getNewsArticleSchema = (author, descriptionText, sections, slug, subject) => {
  const path = getRedirectionPath(`/editorial/${slug as string}`);
  return JSON.stringify({
    '@context': 'http://schema.org',
    '@type': 'NewsArticle',
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `https://www.goat.com${path}`,
    },
    headline: subject,
    description: descriptionText,
    image: [getImageSourcesForSEO({ sections })],
    author: {
      '@type': 'Person',
      name: author,
    },
    publisher: {
      '@type': 'Organization',
      name: 'GOAT',
      logo: {
        '@type': 'ImageObject',
        url: 'https://www.goat.com/public/goat-logo.png',
        height: '750px',
        width: '750px',
      },
    },
  });
};
